import { render, staticRenderFns } from "./FilesAndAttachments.vue?vue&type=template&id=2c72273f"
import script from "./FilesAndAttachments.vue?vue&type=script&lang=js"
export * from "./FilesAndAttachments.vue?vue&type=script&lang=js"
import style0 from "./FilesAndAttachments.vue?vue&type=style&index=0&id=2c72273f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports